/**
 * Collect.js (NMI hosted card fields) script loader — one singleton tag per
 * page. Shared by the NMI forms that tokenize a card inline (restart-plan
 * "use a new card", make-a-payment "use a different card").
 */

export const COLLECT_JS_BASE = (typeof window !== 'undefined' && window.NMI_API_BASE_URL)
  ? window.NMI_API_BASE_URL
  : 'https://vectorpayments.transactiongateway.com';

export const COLLECT_JS_SCRIPT_ID = 'nmi-collect-js';

export function loadCollectJs(tokenizationKey) {
  if (typeof window === 'undefined') return Promise.reject(new Error('SSR'));
  if (window.CollectJS) return Promise.resolve(window.CollectJS);
  const existing = document.getElementById(COLLECT_JS_SCRIPT_ID);
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener('load', () => resolve(window.CollectJS), { once: true });
      existing.addEventListener('error', () => reject(new Error('Collect.js failed to load')), { once: true });
    });
  }
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.id = COLLECT_JS_SCRIPT_ID;
    s.src = `${COLLECT_JS_BASE}/token/Collect.js`;
    if (tokenizationKey) s.setAttribute('data-tokenization-key', tokenizationKey);
    s.async = true;
    s.onload = () => resolve(window.CollectJS);
    s.onerror = () => reject(new Error('Collect.js failed to load'));
    document.head.appendChild(s);
  });
}
